var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "checkbox-list-filter"
  }, [_c('InputText', {
    attrs: {
      "placeholder": "Поиск",
      "icon-right": "search"
    },
    model: {
      value: _vm.query,
      callback: function ($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.innerList.length,
      expression: "innerList.length"
    }],
    staticClass: "checkbox-list-filter__list"
  }, _vm._l(_vm.innerList, function (el) {
    return _c('div', {
      key: el.property,
      staticClass: "checkbox-list-filter__item"
    }, [_c('Checkbox', {
      staticClass: "checkbox-list-filter__checkbox",
      attrs: {
        "checked": !!_vm.value[el.property],
        "name": el.name,
        "data-e2e": "catalog-checkbox-list-filter"
      },
      on: {
        "change": function ($event) {
          return _vm.change({
            property: el.property,
            name: el.name,
            value: $event ? el.value : null
          });
        }
      }
    }, [_c('div', {
      staticClass: "checkbox-list-filter__text"
    }, [_c('div', {
      staticClass: "checkbox-list-filter__text-name"
    }, [_vm._v("\n            " + _vm._s(el.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "checkbox-list-filter__text-count"
    }, [_vm._v("\n            " + _vm._s(el.count) + "\n          ")])])])], 1);
  }), 0), _vm._v(" "), _c('StatusBlock', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.innerList.length === 0,
      expression: "innerList.length === 0"
    }],
    attrs: {
      "title": "Фильтры не найдены",
      "size": "m",
      "type": "empty",
      "margin": "auto"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }